export default "__VITE_ASSET__DgSwZxdN__"